import * as mod from 'common-ui/lib/common/_helper/Customizer/CustomizerProvider';

export default mod.default;
